import { useMutation } from "react-query";
import { editEmployee } from "../../../../../actions/Employees";

//   const { mutate } = useMutation((newEmp) => editEmployee({ ...newEmp }), {

//   return mutate;
// };
// export default useEditEmployee;

const useEditEmployee = () => {
  return useMutation(editEmployee);
};
export default useEditEmployee;
